// import { Button } from "../../Atoms/Button";
// import capacity from "../../Assets/products_landing/capacity.svg";
import bgRing from '../../Assets/home/product_carousel/circle.svg';
import { Button } from '../../Atoms';
import React, {useState} from "react";
import { useNavigate } from 'react-router-dom';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import Slider from 'react-slick';
import FormModal from "../ProductsLanding/FormModal";
// doc
import simulator3phase1 from '../../Assets/simulator/simulator3phase1.webp';
import simulator3phase2 from '../../Assets/simulator/simulator3phase2.webp';
 import simulator3phase3 from '../../Assets/simulator/simulator3phase3.webp';
 import simulator3phase4 from '../../Assets/simulator/simulator3phase4.webp';


export default function Simulator() {
  let activeIdx = 0;
  const tabData = [
    {
      title: 'Three-Phase EV Simulator',
      desc: 'A portable solution for on-field testing and troubleshooting of three-phase Type 2 AC chargers. Simulate EV charging conditions, verify charger operation, and support faster commissioning and diagnostics—without requiring an actual EV.',
      availFrom: 0,
      availTo: false,
      fileLink: "https://resources.verdemobility.com/files/Simulator_Three_Phase_Brochure_V1.pdf",
      imgSrc: simulator3phase1,
    },
  ];

    const sliderSettings2 = {
        dots: true,
        infinite: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
    };

    const navigate = useNavigate();

    const img = [ 
      { title: "", src: simulator3phase3 },
      { title: "", src: simulator3phase2 }, 
      { title: "", src: simulator3phase4 },
    ]
    const [productTitle, setProductTitle] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {

        setIsModalOpen(true)
    };
  return (
    <>
     {/* <section className="blade-padding-top">
      <div className=" max-w-xl lg:max-w-7xl mx-auto w-11/12 px-2 md:px-4">
        <div className=" card-title font-gilroy text-green font-semibold mb-3 md:mb-7 lg:mb-10 max-w-4xl  md:pl-3 xl:max-w-6xl xxl:max-w-7xl mx-auto">
          EV SIMULATOR
        </div>  
        <h3 className="text-center font-gilroy">
        Explore VerdeMobility’s on-field EVSE troubleshooting solutions
        </h3>
       
      </div>
    </section> */}
      <section className="flex lg:flex-row flex-col-reverse gap-3 blade-margin-top-sm relative gap-y-6 bg-light-gradient">
        <div className=" basis-32  xl:basis-20 grow shrink  col-end-7 flex items-center  lg:justify-end px-3 pl-5 lg:pl-20 xl:pl-10">
          <div className="basis-72 mr-0 xl:mr-20 grow shrink  max-w-lg  flex flex-col md:gap-4 xl:gap-4">
            <span className="xxl:text-[48px] xl:text-[40px] lg:text-[40px] md:text-[36px] text-[32px] xl:leading-tight lg:leading-tight md:leading-tight leading-tight font-gilroy font-semibold">
              {tabData[activeIdx].title}
            </span>

            <p className="font-poppins font-light mt-2  text-base  md:text-xl  xl:text-2xl lg:max-w-screen-sm max-w-xl">
              {tabData[activeIdx].desc}
            </p>
            <div className="flex items-center py-2 sm:py-3 gap-3">
              <div >
                {/* <Button
                  title="Contact Us"
                  className="mt-4"
                /> */}
              <a href="/get-in-touch#contact-us"  className='text-gray-600'>
                             <button
                               className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                             >
                               <span className="flex justify-center items-center">
                                 <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                 <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                               </span>
                               Get Quote
                             </button>
                             </a>
              </div>
              <div className='group cursor-pointer'>
              <a href={tabData[activeIdx].fileLink} target="_blank" className='text-gray-600'>
                  <button
                    className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                  >
                    <span className="flex justify-center items-center">
                      <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                      <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                    </span>
                    Brochure
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      <div className="basis-80 grow shrink flex justify-center items-center relative min-h-[300px] sm:min-h-[400px] md:min-h-[550px] lg:min-h-[650px] xxl:min-h-[800px]">
                    {/* Right Gradient Background */}
                    <div className="absolute top-0 bottom-0 right-0 bg-gradient w-24 sm:w-32 md:w-56 lg:w-80 z-0"></div>

                    {/* Slider Container */}
                    <div className="relative z-10 bg-grey rounded-3xl overflow-hidden mx-3 w-full max-w-sm sm:max-w-md md:max-w-[850px] h-[90%] flex items-center justify-center px-4 sm:px-8 md:px-10 lg:px-20">
                        <Slider {...sliderSettings2} className="w-full">
                            {img.map((src, index) => (
                                <div key={index} className="text-center px-2">
                                    <p className="font-poppins text-lg font-medium mb-3">{src.title}</p>
                                    <img
                                        src={src.src}
                                        alt={`slide-${index}`}
                                        className="w-full max-h-[500px] object-contain mx-auto"
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
        </div>
      </section>
  
    </>
  );
}
